import type { MessageKey } from "./ru"

export const svMessages = {
  "common.loading": "Laddar...",
  "common.error": "Fel",
  "common.back": "Tillbaka",
  "common.next": "Nästa",
  "common.search": "Sök",
  "auth.loginErrorTitle": "Inloggningsfel",
  "auth.openViaTelegram": "Öppna appen via Telegram",
  "auth.telegramRequired": "Appen måste öppnas via Telegram",
  "auth.authorizationError": "Auktoriseringsfel",
  "device.rotatePortrait": "Vrid enheten till stående läge",
  "country.brazil": "Brasilien",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egypten",
  "country.india": "Indien",
  "country.indonesia": "Indonesien",
  "country.iran": "Iran",
  "country.spain": "Spanien",
  "country.italy": "Italien",
  "country.kazakhstan": "Kazakstan",
  "country.colombia": "Colombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Mexiko",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Ryssland",
  "country.usa": "USA",
  "country.turkey": "Turkiet",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraina",
  "country.philippines": "Filippinerna",
  "countrySelection.chooseCountry": "Välj land",
  "countrySelection.openAria": "Välj land",
  "languageSelection.chooseLanguage": "Välj språk",
  "commercial.direction.autotrade": "Bilmarknad",
  "commercial.direction.insurance": "Försäkring",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Vägassistans",
  "commercial.searchLabel": "BeepApp-sökning",
  "commercial.cityPlaceholder": "Ange stad",
  "commercial.emptyTitle": "Inga erbjudanden idag",
  "commercial.emptyLine1": "Det finns ännu inga aktiva BeepApp-partner i din stad",
  "commercial.emptyLine2": "Vi arbetar redan med att hitta och ansluta dem",
  "commercial.emptyLine3": "Nya erbjudanden visas här automatiskt",
  "commercial.helperLine1": "Ange din stad för att se",
  "commercial.helperLine2": "tillgängliga erbjudanden",
  "commercial.partnerPrompt": "Vill du bli BeepApp-partner?",
  "commercial.apply": "Ansök",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Signal skickad",
  "main.partnerInviteUnavailable": "Partnerinbjudan är inte tillgänglig",
  "main.enterPlate": "Ange registreringsnummer",
  "main.searchError": "Sökfel",
  "main.signalSendError": "Kunde inte skicka signalen",
  "main.shareCardPrefix": "Registreringskort",
  "main.shareLinkError": "Kunde inte skapa länken",
  "main.searchByPlateAria": "Sök efter registreringsnummer",
  "main.russianPlateAria": "Ryskt registreringsnummer",
  "main.plateAria": "Registreringsnummer",
  "main.findPlateAria": "Hitta registreringsnummer",
  "main.loadingVehicle": "Laddar fordonskort…",
  "main.leaveSignal": "Skicka signal",
  "main.share": "Dela",
  "signalSelection.chooseType": "Välj signaltyp",
  "signalSelection.category.attention": "Personligt",
  "signalSelection.category.road": "Trafik",
  "signalSelection.category.urgent": "Brådskande",
  "signalSelection.chooseSignal": "Välj en signal",
  "signalSelection.suggestOwn": "Föreslå egen",
  "signalConfirmation.title": "Bekräfta signal",
  "signalConfirmation.plateHeading": "Kontrollera registreringsnumret",
  "signalConfirmation.signalHeading": "Kontrollera vald signal",
  "signalConfirmation.replyTitle": "Tillåt svar i Telegram",
  "signalConfirmation.replyBody": "Aktivera detta så att fordonsägaren kan\nskicka meddelanden till dig i Telegram. Svar är bara möjliga om\ndu har ett @username. Beslutet att svara\nligger hos fordonsägaren.",
  "signalConfirmation.consentText": "Jag bekräftar att signalen gäller\nen verklig situation och inte är spam\neller en falsk anmälan.",
  "signalConfirmation.warning": "Efter att signalen skickats\nkan den inte ändras",
  "signalConfirmation.sending": "Skickar…",
  "signalConfirmation.send": "Skicka",
  "partner.loadingAria": "Laddar",
  "partner.title": "Partnerprogram",
  "partner.offerLine1": "Tjäna löpande 30 % på alla betalningar",
  "partner.offerLine2": "från användare som du bjuder in till BeepApp",
  "partner.offerLine3": "via Telegrams affiliateprogram",
  "partner.connectUnavailable": "Anslutning blir tillgänglig när Telegrams affiliateprogram har konfigurerats.",
  "partner.connectTelegram": "Anslut i Telegram",
  "partner.qrAria": "QR-kod för partnerlänk",
  "partner.download": "Ladda ner",
  "partner.promoHeading": "Skapa en personlig kampanjkod",
  "partner.promoHelperLine1": "Kampanjkoden aktiverar ett extra prenumerationsår",
  "partner.promoHelperLine2": "och hjälper till att attrahera användare",
  "partner.promoAria": "Kampanjkod",
  "partner.affiliateHeading": "Din affiliatelänk",
  "partner.affiliateHelper": "Spara länken för att skapa en personlig QR-kod",
  "partner.affiliateAria": "Affiliatelänk",
  "partner.qrNoteLine1": "QR-koden kan placeras på ditt fordon,",
  "partner.qrNoteLine2": "i sociala medier och i reklammaterial",
  "partner.save": "Spara",
  "partner.reset": "Återställ",
  "partner.resetConfirm": "Återställa den sparade affiliatelänken? Kampanjkoden förblir din.",
  "partner.promoFormatError": "Kampanjkoden måste innehålla 4 till 15 tecken.",
  "partner.affiliateHostError": "Endast länkar från t.me eller telegram.me är tillåtna.",
  "partner.affiliatePathError": "Länken innehåller ingen Telegram-sökväg.",
  "partner.affiliateFormatError": "Ogiltig affiliatelänk.",
  "partner.loadError": "Laddningsfel",
  "partner.checkInputError": "Kontrollera den angivna informationen",
  "garageActivation.promoInvalid": "Kampanjkoden är ogiltig",
  "garageActivation.plateOccupied": "Detta registreringsnummer är redan kopplat",
  "garageActivation.activateError": "Kunde inte aktivera Garage",
  "garageEntry.loadJournalError": "Kunde inte ladda loggboken",
  "garageEntry.loadStatusesError": "Kunde inte ladda statusar",
  "garageEntry.activationSuccess": "Garage har aktiverats",
  "garageEntry.plateAttached": "Registreringsnumret är kopplat",
  "garageEntry.attachError": "Kunde inte koppla registreringsnumret",
  "garageEntry.activationNote": "Aktivera ditt Garage",
  "garageSheet.activationTitle": "Garage-aktivering",
  "garageSheet.plateHelper": "Ange fordonets registreringsnummer",
  "garageSheet.promoHelper": "Har du en kampanjkod?",
  "garageSheet.cleanBonusLine1": "Efter aktivering har du 1 timme",
  "garageSheet.cleanBonusLine2": "för en kostnadsfri ”Clean Start”",
  "garageSheet.activationFor": "Aktivering för",
  "garageSheet.cost": "Kostnad",
  "garageSheet.ownerConsentLine1": "Jag bekräftar att jag är ägare",
  "garageSheet.ownerConsentLine2": "till fordonet med det angivna",
  "garageSheet.ownerConsentLine3": "registreringsnumret.",
  "garageSheet.processing": "Bearbetar...",
  "garageSheet.attach": "Koppla",
  "garageSheet.pay": "Betala",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Inaktivera Garage",
  "garageLifecycle.cleanWarningLine1": "Registreringsnumrets historik raderas",
  "garageLifecycle.cleanWarningLine2": "utan möjlighet till återställning!",
  "garageLifecycle.deactivateWarningLine1": "Efter inaktivering upphör åtkomsten till",
  "garageLifecycle.deactivateWarningLine2": "aktiva Garage-funktioner",
  "garageLifecycle.willBeDeleted": "KOMMER ATT RADERAS",
  "garageLifecycle.cleanRemovedLine1": "• Alla poster i loggboken",
  "garageLifecycle.cleanRemovedLine2": "• Historik över mottagna signaler",
  "garageLifecycle.cleanRemovedLine3": "• Offentliga signalräknare",
  "garageLifecycle.cleanRemovedLine4": "  på registreringskortet",
  "garageLifecycle.willRemain": "KOMMER ATT FINNAS KVAR",
  "garageLifecycle.cleanPreservedLine1": "• Kopplingen mellan registreringsnummer och Garage",
  "garageLifecycle.cleanPreservedLine2": "• Återstående aktiveringsperiod",
  "garageLifecycle.cleanPreservedLine3": "• Vald registreringsstatus",
  "garageLifecycle.cleanPreservedLine4": "• Totalt antal kortvisningar",
  "garageLifecycle.freeFirstHour": "Gratis under den första timmen",
  "garageLifecycle.willBecomeUnavailable": "KOMMER ATT BLI OTILLGÄNGLIGT",
  "garageLifecycle.deactivateRemovedLine1": "• Loggbok",
  "garageLifecycle.deactivateRemovedLine2": "• Välja och använda registreringsstatus",
  "garageLifecycle.deactivateRemovedLine3": "• Du lämnar AutoClan automatiskt",
  "garageLifecycle.deactivateRemovedLine4": "• Bilmarknad",
  "garageLifecycle.deactivateRemovedLine5": "• Försäkring",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Vägassistans",
  "garageLifecycle.deactivateRemovedLine8": "• Registreringsnumret kopplas från Garage",
  "garageLifecycle.willRemainAvailable": "FÖRBLIR TILLGÄNGLIGT",
  "garageLifecycle.deactivatePreservedLine1": "• Följeslagare",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Sökning och visning av registreringsnummer",
  "garageLifecycle.deactivatePreservedLine4": "  det offentliga fordonskortet",
  "garageLifecycle.deactivatePreservedLine5": "• Möjlighet att återaktivera",
  "garageLifecycle.deactivatePreservedLine6": "  Garage när som helst",
  "garageLifecycle.cleanConsentLine1": "Jag samtycker till att radera",
  "garageLifecycle.cleanConsentLine2": "hela historiken för detta registreringsnummer",
  "garageLifecycle.cleanConsentLine3": "utan möjlighet till återställning.",
  "garageLifecycle.deactivateConsentLine1": "Jag bekräftar inaktivering och",
  "garageLifecycle.deactivateConsentLine2": "att åtkomst till alla aktiva",
  "garageLifecycle.deactivateConsentLine3": "Garage-funktioner avslutas.",
  "garageLifecycle.clean": "Rensa",
  "garageLifecycle.deactivate": "Inaktivera",
} satisfies Record<MessageKey, string>
